export const countries = [
    {
        "name": "Afghanistan",
        "nameAr": "أفغانستان",
        "code": "AF",
        "continent": "Asia",
        "nationalityEn": "Afghan",
        "nationalityAr": "أفغاني",
        "nationalityArFemale": "أفغانية"
    },
    {
        "name": "Albania",
        "nameAr": "ألبانيا",
        "code": "AL",
        "continent": "Europe",
        "nationalityEn": "Albanian",
        "nationalityAr": "ألباني",
        "nationalityArFemale": "ألبانية"
    },
    {
        "name": "Algeria",
        "nameAr": "الجزائر",
        "code": "DZ",
        "continent": "Africa",
        "nationalityEn": "Algerian",
        "nationalityAr": "جزائري",
        "nationalityArFemale": "جزائرية"
    },
    {
        "name": "Andorra",
        "nameAr": "أندورا",
        "code": "AD",
        "continent": "Europe",
        "nationalityEn": "Andorran",
        "nationalityAr": "أندوري",
        "nationalityArFemale": "أندورية"
    },
    {
        "name": "Angola",
        "nameAr": "أنغولا",
        "code": "AO",
        "continent": "Africa",
        "nationalityEn": "Angolan",
        "nationalityAr": "أنغولي",
        "nationalityArFemale": "أنغولية"
    },
    {
        "name": "Antigua and Barbuda",
        "nameAr": "أنتيغوا وبربودا",
        "code": "AG",
        "continent": "North America",
        "nationalityEn": "Antiguan",
        "nationalityAr": "أنتيغوي",
        "nationalityArFemale": "أنتيغوية"
    },
    {
        "name": "Argentina",
        "nameAr": "الأرجنتين",
        "code": "AR",
        "continent": "South America",
        "nationalityEn": "Argentine",
        "nationalityAr": "أرجنتيني",
        "nationalityArFemale": "أرجنتينية"
    },
    {
        "name": "Armenia",
        "nameAr": "أرمينيا",
        "code": "AM",
        "continent": "Asia",
        "nationalityEn": "Armenian",
        "nationalityAr": "أرميني",
        "nationalityArFemale": "أرمينية"
    },
    {
        "name": "Australia",
        "nameAr": "أستراليا",
        "code": "AU",
        "continent": "Oceania",
        "nationalityEn": "Australian",
        "nationalityAr": "أسترالي",
        "nationalityArFemale": "أسترالية"
    },
    {
        "name": "Austria",
        "nameAr": "النمسا",
        "code": "AT",
        "continent": "Europe",
        "nationalityEn": "Austrian",
        "nationalityAr": "نمساوي",
        "nationalityArFemale": "نمساوية"
    },
    {
        "name": "Azerbaijan",
        "nameAr": "أذربيجان",
        "code": "AZ",
        "continent": "Asia",
        "nationalityEn": "Azerbaijani",
        "nationalityAr": "أذربيجاني",
        "nationalityArFemale": "أذربيجانية"
    },
    {
        "name": "Bahamas",
        "nameAr": "جزر البهاما",
        "code": "BS",
        "continent": "North America",
        "nationalityEn": "Bahamian",
        "nationalityAr": "بهامي",
        "nationalityArFemale": "بهامية"
    },
    {
        "name": "Bahrain",
        "nameAr": "البحرين",
        "code": "BH",
        "continent": "Asia",
        "nationalityEn": "Bahraini",
        "nationalityAr": "بحريني",
        "nationalityArFemale": "بحرينية"
    },
    {
        "name": "Bangladesh",
        "nameAr": "بنغلاديش",
        "code": "BD",
        "continent": "Asia",
        "nationalityEn": "Bangladeshi",
        "nationalityAr": "بنغلاديشي",
        "nationalityArFemale": "بنغلاديشية"
    },
    {
        "name": "Barbados",
        "nameAr": "بربادوس",
        "code": "BB",
        "continent": "North America",
        "nationalityEn": "Barbadian",
        "nationalityAr": "بربادوسي",
        "nationalityArFemale": "بربادوسية"
    },
    {
        "name": "Belarus",
        "nameAr": "بيلاروسيا",
        "code": "BY",
        "continent": "Europe",
        "nationalityEn": "Belarusian",
        "nationalityAr": "بيلاروسي",
        "nationalityArFemale": "بيلاروسية"
    },
    {
        "name": "Belgium",
        "nameAr": "بلجيكا",
        "code": "BE",
        "continent": "Europe",
        "nationalityEn": "Belgian",
        "nationalityAr": "بلجيكي",
        "nationalityArFemale": "بلجيكية"
    },
    {
        "name": "Belize",
        "nameAr": "بليز",
        "code": "BZ",
        "continent": "North America",
        "nationalityEn": "Belizean",
        "nationalityAr": "بليزي",
        "nationalityArFemale": "بليزية"
    },
    {
        "name": "Benin",
        "nameAr": "بنين",
        "code": "BJ",
        "continent": "Africa",
        "nationalityEn": "Beninese",
        "nationalityAr": "بنيني",
        "nationalityArFemale": "بنينية"
    },
    {
        "name": "Bhutan",
        "nameAr": "بوتان",
        "code": "BT",
        "continent": "Asia",
        "nationalityEn": "Bhutanese",
        "nationalityAr": "بوتاني",
        "nationalityArFemale": "بوتانية"
    },
    {
        "name": "Bolivia",
        "nameAr": "بوليفيا",
        "code": "BO",
        "continent": "South America",
        "nationalityEn": "Bolivian",
        "nationalityAr": "بوليفي",
        "nationalityArFemale": "بوليفية"
    },
    {
        "name": "Bosnia and Herzegovina",
        "nameAr": "البوسنة والهرسك",
        "code": "BA",
        "continent": "Europe",
        "nationalityEn": "Bosnian",
        "nationalityAr": "بوسني",
        "nationalityArFemale": "بوسنية"
    },
    {
        "name": "Botswana",
        "nameAr": "بوتسوانا",
        "code": "BW",
        "continent": "Africa",
        "nationalityEn": "Motswana",
        "nationalityAr": "بوتسواني",
        "nationalityArFemale": "بوتسوانية"
    },
    {
        "name": "Brazil",
        "nameAr": "البرازيل",
        "code": "BR",
        "continent": "South America",
        "nationalityEn": "Brazilian",
        "nationalityAr": "برازيلي",
        "nationalityArFemale": "برازيلية"
    },
    {
        "name": "Brunei",
        "nameAr": "بروناي",
        "code": "BN",
        "continent": "Asia",
        "nationalityEn": "Bruneian",
        "nationalityAr": "بروناي",
        "nationalityArFemale": "بروناية"
    },
    {
        "name": "Bulgaria",
        "nameAr": "بلغاريا",
        "code": "BG",
        "continent": "Europe",
        "nationalityEn": "Bulgarian",
        "nationalityAr": "بلغاري",
        "nationalityArFemale": "بلغارية"
    },
    {
        "name": "Burkina Faso",
        "nameAr": "بوركينا فاسو",
        "code": "BF",
        "continent": "Africa",
        "nationalityEn": "Burkinabe",
        "nationalityAr": "بوركيني",
        "nationalityArFemale": "بوركينية"
    },
    {
        "name": "Burundi",
        "nameAr": "بوروندي",
        "code": "BI",
        "continent": "Africa",
        "nationalityEn": "Burundian",
        "nationalityAr": "بوروندي",
        "nationalityArFemale": "بوروندية"
    },
    {
        "name": "Cambodia",
        "nameAr": "كمبوديا",
        "code": "KH",
        "continent": "Asia",
        "nationalityEn": "Cambodian",
        "nationalityAr": "كمبودي",
        "nationalityArFemale": "كمبودية"
    },
    {
        "name": "Cameroon",
        "nameAr": "الكاميرون",
        "code": "CM",
        "continent": "Africa",
        "nationalityEn": "Cameroonian",
        "nationalityAr": "كاميروني",
        "nationalityArFemale": "كاميرونية"
    },
    {
        "name": "Canada",
        "nameAr": "كندا",
        "code": "CA",
        "continent": "North America",
        "nationalityEn": "Canadian",
        "nationalityAr": "كندي",
        "nationalityArFemale": "كندية"
    },
    {
        "name": "Cape Verde",
        "nameAr": "الرأس الأخضر",
        "code": "CV",
        "continent": "Africa",
        "nationalityEn": "Cape Verdean",
        "nationalityAr": "الرأس الأخضري",
        "nationalityArFemale": "الرأس الأخضرية"
    },
    {
        "name": "Central African Republic",
        "nameAr": "جمهورية أفريقيا الوسطى",
        "code": "CF",
        "continent": "Africa",
        "nationalityEn": "Central African",
        "nationalityAr": "أفريقي وسطي",
        "nationalityArFemale": "أفريقية وسطية"
    },
    {
        "name": "Chad",
        "nameAr": "تشاد",
        "code": "TD",
        "continent": "Africa",
        "nationalityEn": "Chadian",
        "nationalityAr": "تشادي",
        "nationalityArFemale": "تشادية"
    },
    {
        "name": "Chile",
        "nameAr": "شيلي",
        "code": "CL",
        "continent": "South America",
        "nationalityEn": "Chilean",
        "nationalityAr": "شيلي",
        "nationalityArFemale": "شيلية"
    },
    {
        "name": "China",
        "nameAr": "الصين",
        "code": "CN",
        "continent": "Asia",
        "nationalityEn": "Chinese",
        "nationalityAr": "صيني",
        "nationalityArFemale": "صينية"
    },
    {
        "name": "Colombia",
        "nameAr": "كولومبيا",
        "code": "CO",
        "continent": "South America",
        "nationalityEn": "Colombian",
        "nationalityAr": "كولومبي",
        "nationalityArFemale": "كولومبية"
    },
    {
        "name": "Comoros",
        "nameAr": "جزر القمر",
        "code": "KM",
        "continent": "Africa",
        "nationalityEn": "Comorian",
        "nationalityAr": "قمري",
        "nationalityArFemale": "قمرية"
    },
    {
        "name": "Congo",
        "nameAr": "الكونغو",
        "code": "CG",
        "continent": "Africa",
        "nationalityEn": "Congolese",
        "nationalityAr": "كونغولي",
        "nationalityArFemale": "كونغولية"
    },
    {
        "name": "Costa Rica",
        "nameAr": "كوستاريكا",
        "code": "CR",
        "continent": "North America",
        "nationalityEn": "Costa Rican",
        "nationalityAr": "كوستاريكي",
        "nationalityArFemale": "كوستاريكية"
    },
    {
        "name": "Croatia",
        "nameAr": "كرواتيا",
        "code": "HR",
        "continent": "Europe",
        "nationalityEn": "Croatian",
        "nationalityAr": "كرواتي",
        "nationalityArFemale": "كرواتية"
    },
    {
        "name": "Cuba",
        "nameAr": "كوبا",
        "code": "CU",
        "continent": "North America",
        "nationalityEn": "Cuban",
        "nationalityAr": "كوبي",
        "nationalityArFemale": "كوبية"
    },
    {
        "name": "Cyprus",
        "nameAr": "قبرص",
        "code": "CY",
        "continent": "Europe",
        "nationalityEn": "Cypriot",
        "nationalityAr": "قبرصي",
        "nationalityArFemale": "قبرصية"
    },
    {
        "name": "Czechia",
        "nameAr": "التشيك",
        "code": "CZ",
        "continent": "Europe",
        "nationalityEn": "Czech",
        "nationalityAr": "تشيكي",
        "nationalityArFemale": "تشيكية"
    },
    {
        "name": "Denmark",
        "nameAr": "الدنمارك",
        "code": "DK",
        "continent": "Europe",
        "nationalityEn": "Danish",
        "nationalityAr": "دنماركي",
        "nationalityArFemale": "دنماركية"
    },
    {
        "name": "Djibouti",
        "nameAr": "جيبوتي",
        "code": "DJ",
        "continent": "Africa",
        "nationalityEn": "Djiboutian",
        "nationalityAr": "جيبوتي",
        "nationalityArFemale": "جيبوتية"
    },
    {
        "name": "Dominica",
        "nameAr": "دومينيكا",
        "code": "DM",
        "continent": "North America",
        "nationalityEn": "Dominican",
        "nationalityAr": "دومينيكي",
        "nationalityArFemale": "دومينيكية"
    },
    {
        "name": "Dominican Republic",
        "nameAr": "جمهورية الدومينيكان",
        "code": "DO",
        "continent": "North America",
        "nationalityEn": "Dominican",
        "nationalityAr": "دومينيكاني",
        "nationalityArFemale": "دومينيكانية"
    },
    {
        "name": "Ecuador",
        "nameAr": "الإكوادور",
        "code": "EC",
        "continent": "South America",
        "nationalityEn": "Ecuadorian",
        "nationalityAr": "إكوادوري",
        "nationalityArFemale": "إكوادورية"
    },
    {
        "name": "Egypt",
        "nameAr": "مصر",
        "code": "EG",
        "continent": "Africa",
        "nationalityEn": "Egyptian",
        "nationalityAr": "مصري",
        "nationalityArFemale": "مصرية"
    },
    {
        "name": "El Salvador",
        "nameAr": "السلفادور",
        "code": "SV",
        "continent": "North America",
        "nationalityEn": "Salvadoran",
        "nationalityAr": "سلفادوري",
        "nationalityArFemale": "سلفادورية"
    },
    {
        "name": "Equatorial Guinea",
        "nameAr": "غينيا الاستوائية",
        "code": "GQ",
        "continent": "Africa",
        "nationalityEn": "Equatorial Guinean",
        "nationalityAr": "غيني استوائي",
        "nationalityArFemale": "غينية استوائية"
    },
    {
        "name": "Eritrea",
        "nameAr": "إريتريا",
        "code": "ER",
        "continent": "Africa",
        "nationalityEn": "Eritrean",
        "nationalityAr": "إريتري",
        "nationalityArFemale": "إريترية"
    },
    {
        "name": "Estonia",
        "nameAr": "إستونيا",
        "code": "EE",
        "continent": "Europe",
        "nationalityEn": "Estonian",
        "nationalityAr": "إستوني",
        "nationalityArFemale": "إستونية"
    },
    {
        "name": "Eswatini",
        "nameAr": "إسواتيني",
        "code": "SZ",
        "continent": "Africa",
        "nationalityEn": "Swazi",
        "nationalityAr": "إسواتيني",
        "nationalityArFemale": "إسواتينية"
    },
    {
        "name": "Ethiopia",
        "nameAr": "إثيوبيا",
        "code": "ET",
        "continent": "Africa",
        "nationalityEn": "Ethiopian",
        "nationalityAr": "إثيوبي",
        "nationalityArFemale": "إثيوبية"
    },
    {
        "name": "Fiji",
        "nameAr": "فيجي",
        "code": "FJ",
        "continent": "Oceania",
        "nationalityEn": "Fijian",
        "nationalityAr": "فيجي",
        "nationalityArFemale": "فيجية"
    },
    {
        "name": "Finland",
        "nameAr": "فنلندا",
        "code": "FI",
        "continent": "Europe",
        "nationalityEn": "Finnish",
        "nationalityAr": "فنلندي",
        "nationalityArFemale": "فنلندية"
    },
    {
        "name": "France",
        "nameAr": "فرنسا",
        "code": "FR",
        "continent": "Europe",
        "nationalityEn": "French",
        "nationalityAr": "فرنسي",
        "nationalityArFemale": "فرنسية"
    },
    {
        "name": "Gabon",
        "nameAr": "الغابون",
        "code": "GA",
        "continent": "Africa",
        "nationalityEn": "Gabonese",
        "nationalityAr": "غابوني",
        "nationalityArFemale": "غابونية"
    },
    {
        "name": "Gambia",
        "nameAr": "غامبيا",
        "code": "GM",
        "continent": "Africa",
        "nationalityEn": "Gambian",
        "nationalityAr": "غامبي",
        "nationalityArFemale": "غامبية"
    },
    {
        "name": "Georgia",
        "nameAr": "جورجيا",
        "code": "GE",
        "continent": "Asia",
        "nationalityEn": "Georgian",
        "nationalityAr": "جورجي",
        "nationalityArFemale": "جورجية"
    },
    {
        "name": "Germany",
        "nameAr": "ألمانيا",
        "code": "DE",
        "continent": "Europe",
        "nationalityEn": "German",
        "nationalityAr": "ألماني",
        "nationalityArFemale": "ألمانية"
    },
    {
        "name": "Ghana",
        "nameAr": "غانا",
        "code": "GH",
        "continent": "Africa",
        "nationalityEn": "Ghanaian",
        "nationalityAr": "غاني",
        "nationalityArFemale": "غانية"
    },
    {
        "name": "Greece",
        "nameAr": "اليونان",
        "code": "GR",
        "continent": "Europe",
        "nationalityEn": "Greek",
        "nationalityAr": "يوناني",
        "nationalityArFemale": "يونانية"
    },
    {
        "name": "Grenada",
        "nameAr": "غرينادا",
        "code": "GD",
        "continent": "North America",
        "nationalityEn": "Grenadian",
        "nationalityAr": "غرينادي",
        "nationalityArFemale": "غرينادية"
    },
    {
        "name": "Guatemala",
        "nameAr": "غواتيمالا",
        "code": "GT",
        "continent": "North America",
        "nationalityEn": "Guatemalan",
        "nationalityAr": "غواتيمالي",
        "nationalityArFemale": "غواتيمالية"
    },
    {
        "name": "Guinea",
        "nameAr": "غينيا",
        "code": "GN",
        "continent": "Africa",
        "nationalityEn": "Guinean",
        "nationalityAr": "غيني",
        "nationalityArFemale": "غينية"
    },
    {
        "name": "Guinea-Bissau",
        "nameAr": "غينيا بيساو",
        "code": "GW",
        "continent": "Africa",
        "nationalityEn": "Guinea-Bissauan",
        "nationalityAr": "غيني بيساوي",
        "nationalityArFemale": "غينية بيساوية"
    },
    {
        "name": "Guyana",
        "nameAr": "غيانا",
        "code": "GY",
        "continent": "South America",
        "nationalityEn": "Guyanese",
        "nationalityAr": "غياني",
        "nationalityArFemale": "غيانية"
    },
    {
        "name": "Haiti",
        "nameAr": "هايتي",
        "code": "HT",
        "continent": "North America",
        "nationalityEn": "Haitian",
        "nationalityAr": "هايتي",
        "nationalityArFemale": "هايتية"
    },
    {
        "name": "Honduras",
        "nameAr": "هندوراس",
        "code": "HN",
        "continent": "North America",
        "nationalityEn": "Honduran",
        "nationalityAr": "هندوراسي",
        "nationalityArFemale": "هندوراسية"
    },
    {
        "name": "Hungary",
        "nameAr": "المجر",
        "code": "HU",
        "continent": "Europe",
        "nationalityEn": "Hungarian",
        "nationalityAr": "مجري",
        "nationalityArFemale": "مجرية"
    },
    {
        "name": "Iceland",
        "nameAr": "آيسلندا",
        "code": "IS",
        "continent": "Europe",
        "nationalityEn": "Icelandic",
        "nationalityAr": "آيسلندي",
        "nationalityArFemale": "آيسلندية"
    },
    {
        "name": "India",
        "nameAr": "الهند",
        "code": "IN",
        "continent": "Asia",
        "nationalityEn": "Indian",
        "nationalityAr": "هندي",
        "nationalityArFemale": "هندية"
    },
    {
        "name": "Indonesia",
        "nameAr": "إندونيسيا",
        "code": "ID",
        "continent": "Asia",
        "nationalityEn": "Indonesian",
        "nationalityAr": "إندونيسي",
        "nationalityArFemale": "إندونيسية"
    },
    {
        "name": "Iran",
        "nameAr": "إيران",
        "code": "IR",
        "continent": "Asia",
        "nationalityEn": "Iranian",
        "nationalityAr": "إيراني",
        "nationalityArFemale": "إيرانية"
    },
    {
        "name": "Iraq",
        "nameAr": "العراق",
        "code": "IQ",
        "continent": "Asia",
        "nationalityEn": "Iraqi",
        "nationalityAr": "عراقي",
        "nationalityArFemale": "عراقية"
    },
    {
        "name": "Ireland",
        "nameAr": "أيرلندا",
        "code": "IE",
        "continent": "Europe",
        "nationalityEn": "Irish",
        "nationalityAr": "أيرلندي",
        "nationalityArFemale": "أيرلندية"
    },
    {
        "name": "Italy",
        "nameAr": "إيطاليا",
        "code": "IT",
        "continent": "Europe",
        "nationalityEn": "Italian",
        "nationalityAr": "إيطالي",
        "nationalityArFemale": "إيطالية"
    },
    {
        "name": "Jamaica",
        "nameAr": "جامايكا",
        "code": "JM",
        "continent": "North America",
        "nationalityEn": "Jamaican",
        "nationalityAr": "جامايكي",
        "nationalityArFemale": "جامايكية"
    },
    {
        "name": "Japan",
        "nameAr": "اليابان",
        "code": "JP",
        "continent": "Asia",
        "nationalityEn": "Japanese",
        "nationalityAr": "ياباني",
        "nationalityArFemale": "يابانية"
    },
    {
        "name": "Jordan",
        "nameAr": "الأردن",
        "code": "JO",
        "continent": "Asia",
        "nationalityEn": "Jordanian",
        "nationalityAr": "أردني",
        "nationalityArFemale": "أردنية"
    },
    {
        "name": "Kazakhstan",
        "nameAr": "كازاخستان",
        "code": "KZ",
        "continent": "Asia",
        "nationalityEn": "Kazakhstani",
        "nationalityAr": "كازاخستاني",
        "nationalityArFemale": "كازاخستانية"
    },
    {
        "name": "Kenya",
        "nameAr": "كينيا",
        "code": "KE",
        "continent": "Africa",
        "nationalityEn": "Kenyan",
        "nationalityAr": "كيني",
        "nationalityArFemale": "كينية"
    },
    {
        "name": "Kiribati",
        "nameAr": "كيريباتي",
        "code": "KI",
        "continent": "Oceania",
        "nationalityEn": "I-Kiribati",
        "nationalityAr": "كيريباتي",
        "nationalityArFemale": "كيريباتية"
    },
    {
        "name": "Kosovo",
        "nameAr": "كوسوفو",
        "code": "XK",
        "continent": "Europe",
        "nationalityEn": "Kosovar",
        "nationalityAr": "كوسوفي",
        "nationalityArFemale": "كوسوفية"
    },
    {
        "name": "Kuwait",
        "nameAr": "الكويت",
        "code": "KW",
        "continent": "Asia",
        "nationalityEn": "Kuwaiti",
        "nationalityAr": "كويتي",
        "nationalityArFemale": "كويتية"
    },
    {
        "name": "Kyrgyzstan",
        "nameAr": "قيرغيزستان",
        "code": "KG",
        "continent": "Asia",
        "nationalityEn": "Kyrgyz",
        "nationalityAr": "قيرغيزي",
        "nationalityArFemale": "قيرغيزية"
    },
    {
        "name": "Laos",
        "nameAr": "لاوس",
        "code": "LA",
        "continent": "Asia",
        "nationalityEn": "Lao",
        "nationalityAr": "لاوسي",
        "nationalityArFemale": "لاوسية"
    },
    {
        "name": "Latvia",
        "nameAr": "لاتفيا",
        "code": "LV",
        "continent": "Europe",
        "nationalityEn": "Latvian",
        "nationalityAr": "لاتفي",
        "nationalityArFemale": "لاتفية"
    },
    {
        "name": "Lebanon",
        "nameAr": "لبنان",
        "code": "LB",
        "continent": "Asia",
        "nationalityEn": "Lebanese",
        "nationalityAr": "لبناني",
        "nationalityArFemale": "لبنانية"
    },
    {
        "name": "Lesotho",
        "nameAr": "ليسوتو",
        "code": "LS",
        "continent": "Africa",
        "nationalityEn": "Basotho",
        "nationalityAr": "ليسوتي",
        "nationalityArFemale": "ليسوتية"
    },
    {
        "name": "Liberia",
        "nameAr": "ليبيريا",
        "code": "LR",
        "continent": "Africa",
        "nationalityEn": "Liberian",
        "nationalityAr": "ليبيري",
        "nationalityArFemale": "ليبيرية"
    },
    {
        "name": "Libya",
        "nameAr": "ليبيا",
        "code": "LY",
        "continent": "Africa",
        "nationalityEn": "Libyan",
        "nationalityAr": "ليبي",
        "nationalityArFemale": "ليبية"
    },
    {
        "name": "Liechtenstein",
        "nameAr": "ليختنشتاين",
        "code": "LI",
        "continent": "Europe",
        "nationalityEn": "Liechtensteiner",
        "nationalityAr": "ليختنشتايني",
        "nationalityArFemale": "ليختنشتاينية"
    },
    {
        "name": "Lithuania",
        "nameAr": "ليتوانيا",
        "code": "LT",
        "continent": "Europe",
        "nationalityEn": "Lithuanian",
        "nationalityAr": "ليتواني",
        "nationalityArFemale": "ليتوانية"
    },
    {
        "name": "Luxembourg",
        "nameAr": "لوكسمبورغ",
        "code": "LU",
        "continent": "Europe",
        "nationalityEn": "Luxembourger",
        "nationalityAr": "لوكسمبورغي",
        "nationalityArFemale": "لوكسمبورغية"
    },
    {
        "name": "Madagascar",
        "nameAr": "مدغشقر",
        "code": "MG",
        "continent": "Africa",
        "nationalityEn": "Malagasy",
        "nationalityAr": "مدغشقري",
        "nationalityArFemale": "مدغشقرية"
    },
    {
        "name": "Malawi",
        "nameAr": "مالاوي",
        "code": "MW",
        "continent": "Africa",
        "nationalityEn": "Malawian",
        "nationalityAr": "مالاوي",
        "nationalityArFemale": "مالاوية"
    },
    {
        "name": "Malaysia",
        "nameAr": "ماليزيا",
        "code": "MY",
        "continent": "Asia",
        "nationalityEn": "Malaysian",
        "nationalityAr": "ماليزي",
        "nationalityArFemale": "ماليزية"
    },
    {
        "name": "Maldives",
        "nameAr": "جزر المالديف",
        "code": "MV",
        "continent": "Asia",
        "nationalityEn": "Maldivian",
        "nationalityAr": "مالديفي",
        "nationalityArFemale": "مالديفية"
    },
    {
        "name": "Mali",
        "nameAr": "مالي",
        "code": "ML",
        "continent": "Africa",
        "nationalityEn": "Malian",
        "nationalityAr": "مالي",
        "nationalityArFemale": "مالية"
    },
    {
        "name": "Malta",
        "nameAr": "مالطا",
        "code": "MT",
        "continent": "Europe",
        "nationalityEn": "Maltese",
        "nationalityAr": "مالطي",
        "nationalityArFemale": "مالطية"
    },
    {
        "name": "Marshall Islands",
        "nameAr": "جزر مارشال",
        "code": "MH",
        "continent": "Oceania",
        "nationalityEn": "Marshallese",
        "nationalityAr": "مارشالي",
        "nationalityArFemale": "مارشالية"
    },
    {
        "name": "Mauritania",
        "nameAr": "موريتانيا",
        "code": "MR",
        "continent": "Africa",
        "nationalityEn": "Mauritanian",
        "nationalityAr": "موريتاني",
        "nationalityArFemale": "موريتانية"
    },
    {
        "name": "Mauritius",
        "nameAr": "موريشيوس",
        "code": "MU",
        "continent": "Africa",
        "nationalityEn": "Mauritian",
        "nationalityAr": "موريشيوسي",
        "nationalityArFemale": "موريشيوسية"
    },
    {
        "name": "Mexico",
        "nameAr": "المكسيك",
        "code": "MX",
        "continent": "North America",
        "nationalityEn": "Mexican",
        "nationalityAr": "مكسيكي",
        "nationalityArFemale": "مكسيكية"
    },
    {
        "name": "Micronesia",
        "nameAr": "ميكرونيزيا",
        "code": "FM",
        "continent": "Oceania",
        "nationalityEn": "Micronesian",
        "nationalityAr": "ميكرونيزي",
        "nationalityArFemale": "ميكرونيزية"
    },
    {
        "name": "Moldova",
        "nameAr": "مولدوفا",
        "code": "MD",
        "continent": "Europe",
        "nationalityEn": "Moldovan",
        "nationalityAr": "مولدوفي",
        "nationalityArFemale": "مولدوفية"
    },
    {
        "name": "Monaco",
        "nameAr": "موناكو",
        "code": "MC",
        "continent": "Europe",
        "nationalityEn": "Monacan",
        "nationalityAr": "موناكي",
        "nationalityArFemale": "موناكية"
    },
    {
        "name": "Mongolia",
        "nameAr": "منغوليا",
        "code": "MN",
        "continent": "Asia",
        "nationalityEn": "Mongolian",
        "nationalityAr": "منغولي",
        "nationalityArFemale": "منغولية"
    },
    {
        "name": "Montenegro",
        "nameAr": "الجبل الأسود",
        "code": "ME",
        "continent": "Europe",
        "nationalityEn": "Montenegrin",
        "nationalityAr": "مونتنيغري",
        "nationalityArFemale": "مونتنيغرية"
    },
    {
        "name": "Morocco",
        "nameAr": "المغرب",
        "code": "MA",
        "continent": "Africa",
        "nationalityEn": "Moroccan",
        "nationalityAr": "مغربي",
        "nationalityArFemale": "مغربية"
    },
    {
        "name": "Mozambique",
        "nameAr": "موزمبيق",
        "code": "MZ",
        "continent": "Africa",
        "nationalityEn": "Mozambican",
        "nationalityAr": "موزمبيقي",
        "nationalityArFemale": "موزمبيقية"
    },
    {
        "name": "Myanmar",
        "nameAr": "ميانمار",
        "code": "MM",
        "continent": "Asia",
        "nationalityEn": "Burmese",
        "nationalityAr": "ميانماري",
        "nationalityArFemale": "ميانمارية"
    },
    {
        "name": "Namibia",
        "nameAr": "ناميبيا",
        "code": "NA",
        "continent": "Africa",
        "nationalityEn": "Namibian",
        "nationalityAr": "ناميبي",
        "nationalityArFemale": "ناميبية"
    },
    {
        "name": "Nauru",
        "nameAr": "ناورو",
        "code": "NR",
        "continent": "Oceania",
        "nationalityEn": "Nauruan",
        "nationalityAr": "ناوري",
        "nationalityArFemale": "ناورية"
    },
    {
        "name": "Nepal",
        "nameAr": "نيبال",
        "code": "NP",
        "continent": "Asia",
        "nationalityEn": "Nepali",
        "nationalityAr": "نيبالي",
        "nationalityArFemale": "نيبالية"
    },
    {
        "name": "Netherlands",
        "nameAr": "هولندا",
        "code": "NL",
        "continent": "Europe",
        "nationalityEn": "Dutch",
        "nationalityAr": "هولندي",
        "nationalityArFemale": "هولندية"
    },
    {
        "name": "New Zealand",
        "nameAr": "نيوزيلندا",
        "code": "NZ",
        "continent": "Oceania",
        "nationalityEn": "New Zealander",
        "nationalityAr": "نيوزيلندي",
        "nationalityArFemale": "نيوزيلندية"
    },
    {
        "name": "Nicaragua",
        "nameAr": "نيكاراغوا",
        "code": "NI",
        "continent": "North America",
        "nationalityEn": "Nicaraguan",
        "nationalityAr": "نيكاراغوي",
        "nationalityArFemale": "نيكاراغوية"
    },
    {
        "name": "Niger",
        "nameAr": "النيجر",
        "code": "NE",
        "continent": "Africa",
        "nationalityEn": "Nigerien",
        "nationalityAr": "نيجري",
        "nationalityArFemale": "نيجرية"
    },
    {
        "name": "Nigeria",
        "nameAr": "نيجيريا",
        "code": "NG",
        "continent": "Africa",
        "nationalityEn": "Nigerian",
        "nationalityAr": "نيجيري",
        "nationalityArFemale": "نيجيرية"
    },
    {
        "name": "North Korea",
        "nameAr": "كوريا الشمالية",
        "code": "KP",
        "continent": "Asia",
        "nationalityEn": "North Korean",
        "nationalityAr": "كوري شمالي",
        "nationalityArFemale": "كورية شمالية"
    },
    {
        "name": "North Macedonia",
        "nameAr": "مقدونيا الشمالية",
        "code": "MK",
        "continent": "Europe",
        "nationalityEn": "North Macedonian",
        "nationalityAr": "مقدوني شمالي",
        "nationalityArFemale": "مقدونية شمالية"
    },
    {
        "name": "Norway",
        "nameAr": "النرويج",
        "code": "NO",
        "continent": "Europe",
        "nationalityEn": "Norwegian",
        "nationalityAr": "نرويجي",
        "nationalityArFemale": "نرويجية"
    },
    {
        "name": "Oman",
        "nameAr": "عمان",
        "code": "OM",
        "continent": "Asia",
        "nationalityEn": "Omani",
        "nationalityAr": "عماني",
        "nationalityArFemale": "عمانية"
    },
    {
        "name": "Pakistan",
        "nameAr": "باكستان",
        "code": "PK",
        "continent": "Asia",
        "nationalityEn": "Pakistani",
        "nationalityAr": "باكستاني",
        "nationalityArFemale": "باكستانية"
    },
    {
        "name": "Palau",
        "nameAr": "بالاو",
        "code": "PW",
        "continent": "Oceania",
        "nationalityEn": "Palauan",
        "nationalityAr": "بالاوي",
        "nationalityArFemale": "بالاوية"
    },
    {
        "name": "Palestine",
        "nameAr": "فلسطين",
        "code": "PS",
        "continent": "Asia",
        "nationalityEn": "Palestinian",
        "nationalityAr": "فلسطيني",
        "nationalityArFemale": "فلسطينية"
    },
    {
        "name": "Panama",
        "nameAr": "بنما",
        "code": "PA",
        "continent": "North America",
        "nationalityEn": "Panamanian",
        "nationalityAr": "بنمي",
        "nationalityArFemale": "بنمية"
    },
    {
        "name": "Papua New Guinea",
        "nameAr": "بابوا غينيا الجديدة",
        "code": "PG",
        "continent": "Oceania",
        "nationalityEn": "Papua New Guinean",
        "nationalityAr": "بابوي",
        "nationalityArFemale": "بابوية"
    },
    {
        "name": "Paraguay",
        "nameAr": "باراغواي",
        "code": "PY",
        "continent": "South America",
        "nationalityEn": "Paraguayan",
        "nationalityAr": "باراغواي",
        "nationalityArFemale": "باراغواية"
    },
    {
        "name": "Peru",
        "nameAr": "بيرو",
        "code": "PE",
        "continent": "South America",
        "nationalityEn": "Peruvian",
        "nationalityAr": "بيروفي",
        "nationalityArFemale": "بيروفية"
    },
    {
        "name": "Philippines",
        "nameAr": "الفلبين",
        "code": "PH",
        "continent": "Asia",
        "nationalityEn": "Filipino",
        "nationalityAr": "فلبيني",
        "nationalityArFemale": "فلبينية"
    },
    {
        "name": "Poland",
        "nameAr": "بولندا",
        "code": "PL",
        "continent": "Europe",
        "nationalityEn": "Polish",
        "nationalityAr": "بولندي",
        "nationalityArFemale": "بولندية"
    },
    {
        "name": "Portugal",
        "nameAr": "البرتغال",
        "code": "PT",
        "continent": "Europe",
        "nationalityEn": "Portuguese",
        "nationalityAr": "برتغالي",
        "nationalityArFemale": "برتغالية"
    },
    {
        "name": "Qatar",
        "nameAr": "قطر",
        "code": "QA",
        "continent": "Asia",
        "nationalityEn": "Qatari",
        "nationalityAr": "قطري",
        "nationalityArFemale": "قطرية"
    },
    {
        "name": "Romania",
        "nameAr": "رومانيا",
        "code": "RO",
        "continent": "Europe",
        "nationalityEn": "Romanian",
        "nationalityAr": "روماني",
        "nationalityArFemale": "رومانية"
    },
    {
        "name": "Russia",
        "nameAr": "روسيا",
        "code": "RU",
        "continent": "Europe",
        "nationalityEn": "Russian",
        "nationalityAr": "روسي",
        "nationalityArFemale": "روسية"
    },
    {
        "name": "Rwanda",
        "nameAr": "رواندا",
        "code": "RW",
        "continent": "Africa",
        "nationalityEn": "Rwandan",
        "nationalityAr": "رواندي",
        "nationalityArFemale": "رواندية"
    },
    {
        "name": "Saint Kitts and Nevis",
        "nameAr": "سانت كيتس ونيفيس",
        "code": "KN",
        "continent": "North America",
        "nationalityEn": "Kittitian",
        "nationalityAr": "سانت كيتسي",
        "nationalityArFemale": "سانت كيتسية"
    },
    {
        "name": "Saint Lucia",
        "nameAr": "سانت لوسيا",
        "code": "LC",
        "continent": "North America",
        "nationalityEn": "Saint Lucian",
        "nationalityAr": "سانت لوسي",
        "nationalityArFemale": "سانت لوسية"
    },
    {
        "name": "Saint Vincent and the Grenadines",
        "nameAr": "سانت فنسنت والغرينادين",
        "code": "VC",
        "continent": "North America",
        "nationalityEn": "Vincentian",
        "nationalityAr": "سانت فنسنتي",
        "nationalityArFemale": "سانت فنسنتية"
    },
    {
        "name": "Samoa",
        "nameAr": "ساموا",
        "code": "WS",
        "continent": "Oceania",
        "nationalityEn": "Samoan",
        "nationalityAr": "ساموي",
        "nationalityArFemale": "ساموية"
    },
    {
        "name": "San Marino",
        "nameAr": "سان مارينو",
        "code": "SM",
        "continent": "Europe",
        "nationalityEn": "Sammarinese",
        "nationalityAr": "سان ماريني",
        "nationalityArFemale": "سان مارينية"
    },
    {
        "name": "Sao Tome and Principe",
        "nameAr": "ساو تومي وبرينسيبي",
        "code": "ST",
        "continent": "Africa",
        "nationalityEn": "Sao Tomean",
        "nationalityAr": "ساو تومي",
        "nationalityArFemale": "ساو تومية"
    },
    {
        "name": "Saudi Arabia",
        "nameAr": "المملكة العربية السعودية",
        "code": "SA",
        "continent": "Asia",
        "nationalityEn": "Saudi",
        "nationalityAr": "سعودي",
        "nationalityArFemale": "سعودية"
    },
    {
        "name": "Senegal",
        "nameAr": "السنغال",
        "code": "SN",
        "continent": "Africa",
        "nationalityEn": "Senegalese",
        "nationalityAr": "سنغالي",
        "nationalityArFemale": "سنغالية"
    },
    {
        "name": "Serbia",
        "nameAr": "صربيا",
        "code": "RS",
        "continent": "Europe",
        "nationalityEn": "Serbian",
        "nationalityAr": "صربي",
        "nationalityArFemale": "صربية"
    },
    {
        "name": "Seychelles",
        "nameAr": "سيشل",
        "code": "SC",
        "continent": "Africa",
        "nationalityEn": "Seychellois",
        "nationalityAr": "سيشلي",
        "nationalityArFemale": "سيشلية"
    },
    {
        "name": "Sierra Leone",
        "nameAr": "سيراليون",
        "code": "SL",
        "continent": "Africa",
        "nationalityEn": "Sierra Leonean",
        "nationalityAr": "سيراليوني",
        "nationalityArFemale": "سيراليونية"
    },
    {
        "name": "Singapore",
        "nameAr": "سنغافورة",
        "code": "SG",
        "continent": "Asia",
        "nationalityEn": "Singaporean",
        "nationalityAr": "سنغافوري",
        "nationalityArFemale": "سنغافورية"
    },
    {
        "name": "Slovakia",
        "nameAr": "سلوفاكيا",
        "code": "SK",
        "continent": "Europe",
        "nationalityEn": "Slovak",
        "nationalityAr": "سلوفاكي",
        "nationalityArFemale": "سلوفاكية"
    },
    {
        "name": "Slovenia",
        "nameAr": "سلوفينيا",
        "code": "SI",
        "continent": "Europe",
        "nationalityEn": "Slovenian",
        "nationalityAr": "سلوفيني",
        "nationalityArFemale": "سلوفينية"
    },
    {
        "name": "Solomon Islands",
        "nameAr": "جزر سليمان",
        "code": "SB",
        "continent": "Oceania",
        "nationalityEn": "Solomon Islander",
        "nationalityAr": "سليماني",
        "nationalityArFemale": "سليمانية"
    },
    {
        "name": "Somalia",
        "nameAr": "الصومال",
        "code": "SO",
        "continent": "Africa",
        "nationalityEn": "Somali",
        "nationalityAr": "صومالي",
        "nationalityArFemale": "صومالية"
    },
    {
        "name": "South Africa",
        "nameAr": "جنوب أفريقيا",
        "code": "ZA",
        "continent": "Africa",
        "nationalityEn": "South African",
        "nationalityAr": "جنوب أفريقي",
        "nationalityArFemale": "جنوب أفريقية"
    },
    {
        "name": "South Korea",
        "nameAr": "كوريا الجنوبية",
        "code": "KR",
        "continent": "Asia",
        "nationalityEn": "South Korean",
        "nationalityAr": "كوري جنوبي",
        "nationalityArFemale": "كورية جنوبية"
    },
    {
        "name": "South Sudan",
        "nameAr": "جنوب السودان",
        "code": "SS",
        "continent": "Africa",
        "nationalityEn": "South Sudanese",
        "nationalityAr": "جنوب سوداني",
        "nationalityArFemale": "جنوب سودانية"
    },
    {
        "name": "Spain",
        "nameAr": "إسبانيا",
        "code": "ES",
        "continent": "Europe",
        "nationalityEn": "Spanish",
        "nationalityAr": "إسباني",
        "nationalityArFemale": "إسبانية"
    },
    {
        "name": "Sri Lanka",
        "nameAr": "سريلانكا",
        "code": "LK",
        "continent": "Asia",
        "nationalityEn": "Sri Lankan",
        "nationalityAr": "سريلانكي",
        "nationalityArFemale": "سريلانكية"
    },
    {
        "name": "Sudan",
        "nameAr": "السودان",
        "code": "SD",
        "continent": "Africa",
        "nationalityEn": "Sudanese",
        "nationalityAr": "سوداني",
        "nationalityArFemale": "سودانية"
    },
    {
        "name": "Suriname",
        "nameAr": "سورينام",
        "code": "SR",
        "continent": "South America",
        "nationalityEn": "Surinamese",
        "nationalityAr": "سورينامي",
        "nationalityArFemale": "سورينامية"
    },
    {
        "name": "Sweden",
        "nameAr": "السويد",
        "code": "SE",
        "continent": "Europe",
        "nationalityEn": "Swedish",
        "nationalityAr": "سويدي",
        "nationalityArFemale": "سويدية"
    },
    {
        "name": "Switzerland",
        "nameAr": "سويسرا",
        "code": "CH",
        "continent": "Europe",
        "nationalityEn": "Swiss",
        "nationalityAr": "سويسري",
        "nationalityArFemale": "سويسرية"
    },
    {
        "name": "Syria",
        "nameAr": "سوريا",
        "code": "SY",
        "continent": "Asia",
        "nationalityEn": "Syrian",
        "nationalityAr": "سوري",
        "nationalityArFemale": "سورية"
    },
    {
        "name": "Taiwan",
        "nameAr": "تايوان",
        "code": "TW",
        "continent": "Asia",
        "nationalityEn": "Taiwanese",
        "nationalityAr": "تايواني",
        "nationalityArFemale": "تايوانية"
    },
    {
        "name": "Tajikistan",
        "nameAr": "طاجيكستان",
        "code": "TJ",
        "continent": "Asia",
        "nationalityEn": "Tajik",
        "nationalityAr": "طاجيكي",
        "nationalityArFemale": "طاجيكية"
    },
    {
        "name": "Tanzania",
        "nameAr": "تنزانيا",
        "code": "TZ",
        "continent": "Africa",
        "nationalityEn": "Tanzanian",
        "nationalityAr": "تنزاني",
        "nationalityArFemale": "تنزانية"
    },
    {
        "name": "Thailand",
        "nameAr": "تايلاند",
        "code": "TH",
        "continent": "Asia",
        "nationalityEn": "Thai",
        "nationalityAr": "تايلاندي",
        "nationalityArFemale": "تايلاندية"
    },
    {
        "name": "Timor-Leste",
        "nameAr": "تيمور الشرقية",
        "code": "TL",
        "continent": "Asia",
        "nationalityEn": "Timorese",
        "nationalityAr": "تيموري",
        "nationalityArFemale": "تيمورية"
    },
    {
        "name": "Togo",
        "nameAr": "توغو",
        "code": "TG",
        "continent": "Africa",
        "nationalityEn": "Togolese",
        "nationalityAr": "توغولي",
        "nationalityArFemale": "توغولية"
    },
    {
        "name": "Tonga",
        "nameAr": "تونغا",
        "code": "TO",
        "continent": "Oceania",
        "nationalityEn": "Tongan",
        "nationalityAr": "تونغي",
        "nationalityArFemale": "تونغية"
    },
    {
        "name": "Trinidad and Tobago",
        "nameAr": "ترينيداد وتوباغو",
        "code": "TT",
        "continent": "North America",
        "nationalityEn": "Trinidadian",
        "nationalityAr": "ترينيدادي",
        "nationalityArFemale": "ترينيدادية"
    },
    {
        "name": "Tunisia",
        "nameAr": "تونس",
        "code": "TN",
        "continent": "Africa",
        "nationalityEn": "Tunisian",
        "nationalityAr": "تونسي",
        "nationalityArFemale": "تونسية"
    },
    {
        "name": "Turkey",
        "nameAr": "تركيا",
        "code": "TR",
        "continent": "Asia",
        "nationalityEn": "Turkish",
        "nationalityAr": "تركي",
        "nationalityArFemale": "تركية"
    },
    {
        "name": "Turkmenistan",
        "nameAr": "تركمانستان",
        "code": "TM",
        "continent": "Asia",
        "nationalityEn": "Turkmen",
        "nationalityAr": "تركماني",
        "nationalityArFemale": "تركمانية"
    },
    {
        "name": "Tuvalu",
        "nameAr": "توفالو",
        "code": "TV",
        "continent": "Oceania",
        "nationalityEn": "Tuvaluan",
        "nationalityAr": "توفالي",
        "nationalityArFemale": "توفالية"
    },
    {
        "name": "Uganda",
        "nameAr": "أوغندا",
        "code": "UG",
        "continent": "Africa",
        "nationalityEn": "Ugandan",
        "nationalityAr": "أوغندي",
        "nationalityArFemale": "أوغندية"
    },
    {
        "name": "Ukraine",
        "nameAr": "أوكرانيا",
        "code": "UA",
        "continent": "Europe",
        "nationalityEn": "Ukrainian",
        "nationalityAr": "أوكراني",
        "nationalityArFemale": "أوكرانية"
    },
    {
        "name": "United Arab Emirates",
        "nameAr": "الإمارات العربية المتحدة",
        "code": "AE",
        "continent": "Asia",
        "nationalityEn": "Emirati",
        "nationalityAr": "إماراتي",
        "nationalityArFemale": "إماراتية"
    },
    {
        "name": "United Kingdom",
        "nameAr": "المملكة المتحدة",
        "code": "GB",
        "continent": "Europe",
        "nationalityEn": "British",
        "nationalityAr": "بريطاني",
        "nationalityArFemale": "بريطانية"
    },
    {
        "name": "United States",
        "nameAr": "الولايات المتحدة الأمريكية",
        "code": "US",
        "continent": "North America",
        "nationalityEn": "American",
        "nationalityAr": "أمريكي",
        "nationalityArFemale": "أمريكية"
    },
    {
        "name": "Uruguay",
        "nameAr": "أوروغواي",
        "code": "UY",
        "continent": "South America",
        "nationalityEn": "Uruguayan",
        "nationalityAr": "أوروغواي",
        "nationalityArFemale": "أوروغواية"
    },
    {
        "name": "Uzbekistan",
        "nameAr": "أوزبكستان",
        "code": "UZ",
        "continent": "Asia",
        "nationalityEn": "Uzbek",
        "nationalityAr": "أوزبكي",
        "nationalityArFemale": "أوزبكية"
    },
    {
        "name": "Vanuatu",
        "nameAr": "فانواتو",
        "code": "VU",
        "continent": "Oceania",
        "nationalityEn": "Ni-Vanuatu",
        "nationalityAr": "فانواتي",
        "nationalityArFemale": "فانواتية"
    },
    {
        "name": "Vatican City",
        "nameAr": "الفاتيكان",
        "code": "VA",
        "continent": "Europe",
        "nationalityEn": "Vatican",
        "nationalityAr": "فاتيكاني",
        "nationalityArFemale": "فاتيكانية"
    },
    {
        "name": "Venezuela",
        "nameAr": "فنزويلا",
        "code": "VE",
        "continent": "South America",
        "nationalityEn": "Venezuelan",
        "nationalityAr": "فنزويلي",
        "nationalityArFemale": "فنزويلية"
    },
    {
        "name": "Vietnam",
        "nameAr": "فيتنام",
        "code": "VN",
        "continent": "Asia",
        "nationalityEn": "Vietnamese",
        "nationalityAr": "فيتنامي",
        "nationalityArFemale": "فيتنامية"
    },
    {
        "name": "Yemen",
        "nameAr": "اليمن",
        "code": "YE",
        "continent": "Asia",
        "nationalityEn": "Yemeni",
        "nationalityAr": "يمني",
        "nationalityArFemale": "يمنية"
    },
    {
        "name": "Zambia",
        "nameAr": "زامبيا",
        "code": "ZM",
        "continent": "Africa",
        "nationalityEn": "Zambian",
        "nationalityAr": "زامبي",
        "nationalityArFemale": "زامبية"
    },
    {
        "name": "Zimbabwe",
        "nameAr": "زيمبابوي",
        "code": "ZW",
        "continent": "Africa",
        "nationalityEn": "Zimbabwean",
        "nationalityAr": "زيمبابوي",
        "nationalityArFemale": "زيمبابوية"
    }
];
